//basic
import React, { Component } from 'react';
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';

//style
import './TechnicalDocuments.scss';

//api
import { api } from '../../../../functions/api';

//custom components
import Search from '../../../../components/basic/search';
import CustomButton from '../../../../components/basic/CustomButton';
import CustomTable from '../../../../components/complex/customTable';
import UploadTechDoc from './import';
import DeleteDialog from '../../../../components/global/deleteDialog';

//material-ui
import { CircularProgress } from '@material-ui/core';

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiPlus, mdiUpload } from '@mdi/js';

@inject('internal')
@inject('translate')
@observer
export default class TechnicalDocuments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            loadingTable: true,
            import: false,
        }
    }

    componentDidMount() {
        // this.props.internal.setRoute( this.props.routerData.history, this.props.routerData.location.pathname);
        this.loadTechDocs();
    }

    // definujeme ci sa ma reloadnut tabulka
    tableReload = false;

    // counter ktori sa zvacsuje pri kazdom api cale okrem pri mounte modulu
    // nedovuje aby sa tabulka zobrazila skor ako co pride aj posledna odpoved zo servera
    apiCallCounter = 0;

    tableHeader = [
        {
            "title": "title",
            "numeric": false,
            "min_width": "150px",
            disabled: true, //disable click pre sortovanie
        },
    ];
    tableBody = [
        "filename",
    ]

    dropDownMenuItems = [
        {
            title: this.props.translate.i18n.GLOBAL.BUTTONS.SHOW,
            action: "download"
        },
        {
            title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
            action: "delete"
        },
    ];

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.tableReload = true;
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        this.tableReload = true;

        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.routerData.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadTechDocs()
    }

    loadTechDocs = async (size = 10, page = 0, searchterm = "", by = "filename", dir = "asc") => {
        if(this.tableReload) {
            this.setState({loadingTable: true})
            this.apiCallCounter++;
        }
        
        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let idProduct = this.props.routerData.match.params.idProduct;

        let load_data = await api({
                //products/:id/documents
                method:'get',
                url:`products/${idProduct}/documents`,
                authorization: this.props.internal.user.access_token,
                params:{
                    searchterm: searchterm,
                    page:{
                        number:page,
                        size:size,
                    },
                    order: [
                        {
                            by: by,
                            dir: dir
                        }
                    ]
                }
            // method:'get',
            // url: 'products',
            // authorization: this.props.internal.user.access_token,
            // params:{
            //     searchterm: searchterm,
            //     page:{
            //         number:page,
            //         size:size,
            //     },
            //     order: [
            //         {
            //             by: by,
            //             dir: dir
            //         }
            //     ]
            // }
        })


        if (load_data.success === true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)
                this.setState({loadingTable: false})
            }
        }
        this.setState({loadingPage: false})

        if(this.tableReload) {
            this.apiCallCounter--;
            if(this.apiCallCounter === 0) {
                this.setState({loadingTable: false})
                this.tableReload = false;
            }
        }
    }

    handleUploadTechDocs = (action = false) => {
        this.setState({import: !this.state.import})
        if(action === true) {
            this.loadTechDocs();
        }
    }

    handleDelete = async () => {
        let document_id = toJS(this.props.internal.actionDeleteObj.id);
        let product_id = this.props.routerData.match.params.idProduct;
        let delete_tech_doc = await api({
            method: 'delete',
            url: `products/${product_id}/documents/${document_id}`,
            authorization: this.props.internal.user.access_token,
        });

        if(delete_tech_doc.success === true) {
            this.props.internal.setSnackbar(delete_tech_doc.data.message, true)
            this.loadTechDocs();
            this.props.internal.setActionDelete();
        
        }
    }

    render () {
        return (
            this.state.loadingPage
                ?
                <CircularProgress className={'circular-progress'}/>
                :
                <div className={'tech-docs'}>
                    {this.state.import ?
                        <UploadTechDoc
                            open={this.state.import}
                            title={this.props.translate.i18n.MODULES.PRODUCTS.UPLOAD_TECH_DOC_DIALOG_TITLE}
                            onClose={this.handleUploadTechDocs}
                            routerData={this.props.routerData}
                        />
                        :
                        null
                    }
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.PRODUCTS.DELETE_TECH_DOC_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    <div className={'flex space-between mb-first-line'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.MENU.SEARCH} classes={'admin-search'} onChange={this.handleSearch} value={this.state.searchTerm}/>
                        <CustomButton
                            mystyle = {'btn-orange-bg border-radius-18'}
                            title = {this.props.translate.i18n.MODULES.PRODUCTS.UPLOAD_TECH_DOC}
                            onClick = {this.handleUploadTechDocs}
                        >
                            <Icon path = {mdiUpload} size = {1}/>
                        </CustomButton>
                    </div>
                    {this.state.loadingTable
                        ?
                        <CircularProgress className={'circular-progress'} />
                        :
                        // null
                        <CustomTable
                            dropDownMenuItems={this.dropDownMenuItems}
                            module={'/products'}
                            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                            handleChangePage={this.handleChangePage}
                            handleSort={this.handleSort}
                            header={this.tableHeader}
                            body={this.tableBody}
                            openDialogSiblings={this.openCloseDialogChangePosition}
                            handleChangeType={this.handleChangeType}
                            // disablePagination={true}
                        />
                    }
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/products/edit/techDocs/TechnicalDocuments.jsx